import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import autobind from 'autobind-decorator';
import { AsYouTypeFormatter } from 'google-libphonenumber/dist/libphonenumber';
import MessageDefinitions from '../i18n/MessageDefinitions';
import { textInput } from '../../common/util/FormInput';
import Form from 'react-form-controlled';
import Validate from 'react-form-controlled-validate';
import FontAwesome from 'react-fontawesome';

const schema = {
  type: 'object',
  properties: {
    phone: {
      type: 'string',
      'pattern': '^\\([0-9]{3}\\)\\s*[0-9]{3}-[0-9]{4}$|^[0-9]{10}$'
    }
  },
  required: ['phone']
};

class TextResultsForm extends React.Component {
  static contextTypes = {
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      valid: false,
      form: {
        ...props.form
      }
    }
  }

  @autobind
  valueChanged(state) {
    if (state.phone) {
      state.phone = state.phone.replace(/\D/g, '');
    }
    this.form.validate(state).then((formErrors = []) => {
      this.setState({
        form: state,
        valid: formErrors.length === 0
      });
    });
  }

  @autobind
  formSubmitted(state) {
    const { phone = '' } = state;
    this.setState({
      processing: true
    });
    const finalNumber = `+1${phone.replace(/\D/g, '')}`;
    window.ignite.contactService.textResults(finalNumber).then(result => {
      if (result.status === 'success') {
        if (window.ignite.textResultsSent) {
          window.ignite.textResultsSent();
        }
      }
    });
  }

  componentDidMount() {
    this.valueChanged(this.state.form || {});
  }

  render() {
    const formatMessage = this.context.intl.formatMessage;

    const { processing, valid } = this.state;

    const buttonMessage =
      processing
        ? <FontAwesome name="refresh" spin/>
        : <FormattedMessage {...MessageDefinitions.submitText} />;

    const value = {
      ...this.state.form
    };

    if (value.phone) {
      const formatter = new AsYouTypeFormatter('US');
      let phoneNumber = null;

      for (const n of value.phone || []) {
        phoneNumber = formatter.inputDigit(n);
      }

      value.phone = phoneNumber;
    }

    return (
      <Validate schema={schema} ref={f => this.form = f}>
        <Form value={value}
              className="form-container"
              onChange={this.valueChanged}
              onSubmit={this.formSubmitted}>
          <div className="form-body">
            {
              textInput({
                type: 'tel',
                name: 'phone',
                labelMessage: MessageDefinitions.phone,
                errorMessage: MessageDefinitions.phoneError,
                placeholderMessage: MessageDefinitions.phonePlaceholder,
                hasError: !valid,
                formatMessage
              })
            }
            <div className="form-group muted text-right">
              <FormattedMessage {...MessageDefinitions.carrierCharges} />
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary save" disabled={!valid || processing}>
              {buttonMessage}
            </button>
          </div>
        </Form>
      </Validate>
    );
  }

}

export default TextResultsForm;



/** WEBPACK FOOTER **
 ** ./src/main/js/social/components/TextResultsForm.js
 **/